<template>
  
<FormKitLazyProvider>
<FormKit
    id="review-create"
    ref="reserveForm"
    name="review-create"
    class="review-create"
    type="form"
    :incomplete-message="$t('Sorry, not all fields are filled out correctly.')"
    :actions="false"
    @submit="reservationSubmitMutation"
  >
    <FormKit
      v-model="name"
      type="text"
      name="name"
      :label="$t('Name') + ' *'"
      validation="required"
      :validation-messages="{
        required: $t('This is a required field.'),
      }"
    />

    <FormKit
      v-model="mail"
      type="email"
      name="mail"
      :label="$t('Mail') + ' *'"
      validation="required"
      :validation-messages="{
        required: $t('This is a required field.'),
      }"
    />

    <FormKit
      v-model="telephone"
      type="tel"
      name="telephone"
      :placeholder="$t('Ex. 32123456789 of 31123456789')"
      :label="$t('Phone Number') + ' *'"
      :validation="[['required']]"
      :validation-messages="{
        required: $t('This is a required field.'),
      }"
    />

    <FormKitMessages hidden />

    <div class="formkit-actions">
      <button
        :disabled="!!loading"
        type="submit"
        class="button button--cta button--full"
        :class="{ 'button--loading': loading }"
      >
        <span>{{ $t('Reserve article') }}</span>
        <IconLoader
          v-if="loading"
          class="icon icon--loader"
        />
        <IconArrow class="icon icon--right icon--arrow icon--arrow-right" />
      </button>
    </div>
  </FormKit>
</FormKitLazyProvider>

</template>

<script lang="ts" setup>
import { FormKitLazyProvider } from '@formkit/vue'
const props = defineProps<{
  sku: string
  storeId: string
}>()

const emit = defineEmits<{
  (e: 'reservation-complete', success: boolean): void
}>()

const { t } = useI18n({ useScope: 'global' })
const { show: showNotification } = useNotification()
const { storeReservation } = useDataLayer()

const loading = ref(false)
const submitted = ref(false)
const error = ref(false)

const reservationSubmitMutation = async (details) => {
  loading.value = true
  submitted.value = true

  try {
    storeReservation()
    const result = await useGraphqlMutation(
      'postReservation',
      {
        input: {
          customerName: details.name,
          email: details.mail,
          phone: details.telephone,
          store: parseInt(props.storeId),
          sku: props.sku,
        },
      },
      useGraphqlCustomerClient(),
    )

    if (result?.data?.postReservation) {
      showNotification({
        type: 'success',
        message: t('The product has been reserved successfully.'),
      })

      details.name = ''
      details.email = ''
      details.telephone = ''
    }
    else if (result?.errors?.length) {
      error.value = result.errors
      showNotification({
        type: 'error',
        message: t('There has been an error reserving the product. Please try again later.'),
      })
    }
  }
  catch (err) {
    error.value = err
    showNotification({
      type: 'error',
      message: t('There has been an error reserving the product. Please try again later.'),
    })
  }
  finally {
    emit('reservation-complete', true)
    loading.value = false
  }
}
</script>

<style src="~layers/app/components/Form/ReviewCreate.css" />
